import { siteAccessPoliciesHelp } from './siteAccessPolicies';
import { chargingPartnersHelp } from './chargingPartners';

// Combine all help content into a single object
export const helpContent = {
    ...siteAccessPoliciesHelp,
    ...chargingPartnersHelp,
}; 